import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { SxProps, Theme } from '@mui/material/styles';

type HeaderActionColor = 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

type PageHeaderActionButtonProps = Omit<ButtonProps, 'color' | 'variant'> & {
  color?: HeaderActionColor;
};

/** Outlined page-header action with a matching color fill on hover. */
const PageHeaderActionButton = React.forwardRef<HTMLButtonElement, PageHeaderActionButtonProps>(
  ({ color = 'primary', sx, ...props }, ref) => {
    const customSx = sx ? (Array.isArray(sx) ? sx : [sx]) : [];
    const interactionSx: SxProps<Theme> = theme => {
      const actionColor = theme.palette[color];
      return {
        borderColor: actionColor.main,
        '&:not(.Mui-disabled):hover': {
          borderColor: actionColor.main,
          backgroundColor: actionColor.main,
          color: actionColor.contrastText,
        },
      };
    };

    return <Button {...props} ref={ref} color={color} variant="outlined" sx={[...customSx, interactionSx]} />;
  },
);

PageHeaderActionButton.displayName = 'PageHeaderActionButton';

export default PageHeaderActionButton;
